import { ALTERAR_REGISTROS_POR_PAGINA_VEICULO } from '../types'

export default function alterarRegistrosPorPaginaVeiculos (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_VEICULO,
    payload: valor
  }
}
